import styled from 'styled-components';

export const Collapsible = styled.div<{
  expanded?: boolean;
  elementHeight?: number;
  $mb?: string;
  $mt?: string;
}>`
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  visibility: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  max-height: ${({ expanded, elementHeight }) =>
    expanded ? `${elementHeight}px` : '0px'};
  margin-top: ${(props) => (props.expanded ? props.$mt || '8px' : '0px')};
  margin-bottom: ${(props) => (props.expanded ? props.$mb || '20px' : '0px')};
  /* Collapsed, the box is 0px tall but its content still hangs out below it,
     invisible, and stretches the scroll area into a blank gap. So it clips
     while closed and while opening, and lets go once open (300ms), where the
     shadows and dropdowns inside must not be cut off. Without
     allow-discrete support it lets go at once, which only shows mid-open. */
  overflow: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  transition: all 300ms,
    overflow 0s ${(props) => (props.expanded ? '300ms' : '0s')};
  transition-behavior: allow-discrete;

  @media (min-width: 3500px) {
    margin-top: ${(props) => (props.expanded ? props.$mt || '16px' : '0px')};
    margin-bottom: ${(props) => (props.expanded ? props.$mb || '40px' : '0px')};
  }

  @media (max-width: 800px) {
    margin-top: ${(props) => (props.expanded ? props.$mt || '8px' : '0px')};
    margin-bottom: ${(props) => (props.expanded ? props.$mb || '16px' : '0px')};
  }
`;

export const ItemListImage = styled.div`
  width: 60px;
  height: 60px;
  @media (max-width: 800px) {
    width: 50px;
    height: 50px;
  }
  border-radius: 50%;
  overflow: hidden;

  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;

export const ProgressBarBackground = styled.div`
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.white};
  border-radius: 100px;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  border: ${({ theme }) => `5px solid ${theme.white}`};
`;

export const ProgressBarFill = styled.div<{
  progress?: number;
  $gradient?: boolean;
}>`
  height: 25px;
  margin-left: -25px;
  background-color: ${({ theme }) => theme.primary};
  ${({ $gradient }) =>
    $gradient &&
    `background: linear-gradient(90deg, #306FDE 0.11%, #3A6BDB 32.44%, #7F50C7 68.63%, #BA39B5 100.48%);`}
  border-radius: 100px;
  width: ${({ progress }) => `calc(${progress}% + 25px)`};
  transition: width 0.3s ease;
  @media (max-width: 800px) {
    /* margin-left: -25px;
    width: ${({ progress }) => `calc(${progress}% + 25px)`};
    height: 25px; */
  }
`;

/** The red pause badge heading the Pause Item modal, as on the tablet app. */
export const PauseBadge = styled.div`
  width: 100px;
  height: 100px;
  margin: 0 auto 24px;
  border-radius: 50%;
  background: ${({ theme }) => theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 44px;
    height: 44px;
  }
`;
